const newsRegExp = /^\/(newsroom|news|press|awards)(\/)?$/;
const resourcesRegExp = /^\/(resources)(\/)?$/;
const partnersRegExp = /^\/partners\/(technology|mssp)(\/)?$/;
export const shouldUpdateScroll = ({
  prevRouterProps: { location: prevLocation },
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // hack to override `shouldUpdateScroll` behavior to bypass useQueryParams in product-checkout
  if (
    (resourcesRegExp.test(location.pathname) &&
      (location.search.includes('filter=') ||
        location.search.includes('q=') ||
        location.search.includes('topic='))) ||
    (partnersRegExp.test(location.pathname) &&
      location.search.includes('cat=')) ||
    (newsRegExp.test(location.pathname) &&
      newsRegExp.test(prevLocation.pathname))
  ) {
    return false;
  }
  const currentPosition = getSavedScrollPosition(location);
  return currentPosition || [0, 0];
};
